import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { ChatSmartOfferStep } from "./types";

interface SmartOfferFlowState {
    steps: Record<string, { sku: string; step: ChatSmartOfferStep | null }>;
    getCurrentStep: (sessionId: string) => ChatSmartOfferStep | null;
    updateStep: (sessionId: string, sku: string, step: ChatSmartOfferStep) => void;
    usedActions: Record<string, string[]>;
    markActionAsUsed: (sessionId: string, actionId: string) => void;
    isSmartOfferActionUsed: (sessionId: string, actionId: string) => boolean;
    reset: (sessionId: string) => void;
}

export const useSmartOfferFlowStore = create<SmartOfferFlowState>()(
    persist(
        immer(
            devtools(
                (set, get) => ({
                    steps: {},
                    usedActions: {},
                    getCurrentStep: (sessionId: string) => {
                        return get().steps[sessionId]?.step ?? null;
                    },
                    updateStep: (sessionId: string, sku: string, step: ChatSmartOfferStep) => {
                        set((state) => {
                            state.steps[sessionId] = { sku, step };
                        });
                    },
                    markActionAsUsed: (sessionId: string, actionId: string) => {
                        set((state) => {
                            if (!state.usedActions[sessionId]) {
                                state.usedActions[sessionId] = [];
                            }
                            if (!state.usedActions[sessionId].includes(actionId)) {
                                state.usedActions[sessionId].push(actionId);
                            }
                        });
                    },
                    isSmartOfferActionUsed: (sessionId: string, actionId: string) => {
                        return get().usedActions[sessionId]?.includes(actionId) ?? false;
                    },
                    reset: (sessionId: string) => {
                        set((state) => {
                            delete state.steps[sessionId];
                            delete state.usedActions[sessionId];
                        });
                    },
                }),
                {
                    enabled: import.meta.env.VITE_ENV_TYPE !== "production",
                    store: "smart-offer-flow-store",
                    name: "workspace/chat",
                },
            ),
        ),
        { name: "smart-offer-flow-store" },
    ),
);
